<template>
  <div class="mb-2 md:mb-0">
    <div class="features__wrapper w-full md:px-gap2 lg:container mt-0 md:mt-1">
      <div class="flex flex-wrap">
        <div class="w-12/12 text-center px-1 md:px-0 pt-2 md:py-2 md:py-4">
          <h2>{{ title }}</h2>
        </div>
      </div>
    </div>
    <div
      class="overflow-x-scroll w-full md:overflow-x-auto features__container mb-3"
    >
      <div
        class="features__table-wrapper md:w-auto mb-2 md:mb-0"
        :class="`w-[${60 + 40 * length}vw]`"
      >
        <!-- prevent css purge w-[100vw] w-[140vw] w-[180vw] -->
        <ProductFeaturesHeader
          :product="group"
          :globals="globals"
          :length="length"
          :specs="specs"
          :activeProduct="activeProduct"
        />
        <ProductFeatureTable
          :group="group"
          :product="product"
          :length="length"
          :globals="globals"
          :specs="specs"
          :activeProduct="activeProduct"
        />
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<style lang="scss" scoped>
::-webkit-scrollbar {
  background: #fff;
  border: 1px solid #00263e;
  border-radius: 36px;
  height: 11px;
  width: 90% !important;
}
::-webkit-scrollbar-thumb {
  background: #00263e;
  border-radius: 36px;
  width: 1px;
  width: 90% !important;
}
@media (max-width: 736px) {
  .features__wrapper h2 {
    font-size: 28px;
  }
}
.features__container {
  font-family: 'Roboto';
}
</style>
<script>
import ProductFeaturesHeader from "./ProductFeaturesHeader.vue";
import ProductFeatureTable from "./ProductFeatureTable.vue";
export default {
  components: { ProductFeaturesHeader, ProductFeatureTable },
  props: {
    product: {
      type: [Object, Array],
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
    globals: {
      type: Object,
      required: true,
    },
    activeProduct: {
      type: Object,
      required: true,
    },
    specs: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    group: {
      type: [Object, Array],
      required: true,
    },
  },
};
</script>
